import {
  GET_USERS,
} from 'constants/users';

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_USERS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
